import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { sliceIntoChunks, toAccendingOrder } from "../../../helpers/common";
const Categories = () => {
  useEffect(() => {
    window.scrollTo({
      top: 300,
      behavior: "smooth",
    });
  }, []);

  const allCategories = useSelector((state) => state.categories.data);
  const chunkSize = allCategories.length < 6 ? 2 : allCategories?.length / 3;

  const arrayIntoThreeChunk = sliceIntoChunks(
    toAccendingOrder(allCategories),
    chunkSize
  );

  return (
    <React.Fragment>
      <section className="section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6}>
              <div className="text-center mb-5">
                {/* Soft Badge for context */}
                <span
                  className="badge rounded-pill fw-semibold mb-3 px-3 py-2"
                  style={{
                    backgroundColor: 'rgba(56, 126, 216, 0.15)',
                    color: '#387ed8',
                    fontSize: '13px'
                  }}
                >
                  Explore Opportunities
                </span>

                <h2 className="fw-bold text-dark mb-3">Browse Jobs by <span style={{ color: '#387ed8' }}>Category</span></h2>

                <p className="text-muted mx-auto" style={{ maxWidth: '600px', lineHeight: '1.6' }}>
                  Whether you are a Candidate looking for your next career move or an Employer searching for specialized talent,
                  explore our curated industry categories to find the perfect match for your needs.
                </p>
              </div>
            </Col>
          </Row>

    <Row>
        {arrayIntoThreeChunk.map((categoriesDetails, key) => (
          <Col lg={4} key={key}>
            <Card className="job-Categories-box bg-light border-0 mb-3">
              <CardBody className="p-4">
                <ul className="list-unstyled job-Categories-list mb-0">
                  {(categoriesDetails || []).map((item, key) => {
                    // Check if the user is logged in (adjust token/auth key based on your project)
                    const isLoggedIn = Boolean(localStorage.getItem("webvi_authToken"));

                    return (
                      <li key={key}>
                        <Link
                          to={isLoggedIn ? "/jobs" : "/signin"}
                          className="primary-link"
                        >
                          {item.name}{" "}
                          <span className="badge bg-soft-info float-end">
                            {/* {item.description?.replace(/jobs/gi, "")} */}
                          </span>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
          
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Categories;
